import { XSAuthProvider } from "@xinosolutions/xs-auth-react";
import {
  xsAuthClientId,
  xsAuthUrl,
  xsAuthBootstrapUrl,
  xsAccountUrl,
} from "../../config/config";
import { ProductProvider } from "../../context/ProductContext";

/** Same stack as xs-template-admin-app: XSAuthProvider → ProductSessionProvider. */
export default function AdminProviders({ children }) {
  return (
    <XSAuthProvider
      clientId={xsAuthClientId}
      authBaseUrl={xsAuthUrl}
      bootstrapUrl={xsAuthBootstrapUrl}
      accountUrl={xsAccountUrl}
    >
      <ProductProvider>{children}</ProductProvider>
    </XSAuthProvider>
  );
}
